import type { ReactNode } from 'react'

/**
 * The tag pill repeated identically across Guides, GuideCategory and
 * ArticleDetails. Styles are inline in the original markup and kept byte-for-byte.
 */
export function ArticleTagPill({ children }: { children: ReactNode }) {
  return (
    <span
      style={{
        backgroundColor: 'var(--blue-100)',
        color: 'var(--alrajhi-black)',
        fontWeight: '500',
        padding: '8px 12px',
        fontSize: '14px'
      }}
      className="badge rounded-pill"
    >
      {children}
    </span>
  )
}
